import { HttpInterceptorFn } from '@angular/common/http';

export const fhNullRequestsInterceptor: HttpInterceptorFn = (req, next) => {
  let modifiedParams = req.params;

  req.params.keys().forEach((key) => {
    const value = req.params.get(key);
    if (value === 'null') {
      modifiedParams = modifiedParams.set(key, '');
    }
  });

  const modifiedReq = req.clone({ params: modifiedParams });
  return next(modifiedReq);
};
